import React from "react";
import {CameraIcon} from "../CameraIcon";

export const OntSerialNumberInput = ({
  technicalData,
  onChange,
  startBarcodeScanning
}) => {

  const handleSerialNumberChange = (e) => {
    onChange('ont.serial_number', e.target.value);
  }

  const handleScan = () => {
    startBarcodeScanning('ont.serial_number');
  }

  return (
      <div>
        <label className="block text-xs text-gray-600 mb-1">Seriennummer</label>
        <div className="flex items-center space-x-2">
          <input
              type="text"
              value={technicalData?.ont?.serial_number}
              onChange={handleSerialNumberChange}
              className="flex-1 px-2 py-1 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-orange-500"
              placeholder="Seriennummer"
          />
          <button
              type="button"
              onClick={handleScan}
              className="p-2 text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-md transition-colors"
              title="Barcode scannen"
          >
            <CameraIcon/>
          </button>
        </div>
      </div>);
};